<template>
  <div v-if="warningModal">
    <CModal
      title="Termos do Checklist"
      color="warning"
      :show.sync="warningModal"
    >
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
      quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
      consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
      cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
      proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
    </CModal>
  </div>
</template>

<script>
export default {
  name: 'modal',
  data () {
    return {
      warningModal: false
    }
  },
  created() {
    this.$root.$on('ShowModal::show', payload => {
      this.warningModal = payload.warningModal
    });
  }
}
</script>